import { render, staticRenderFns } from "./WebhookModal.vue?vue&type=template&id=2347e582"
import script from "./WebhookModal.vue?vue&type=script&lang=js"
export * from "./WebhookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports